export default {"src":"/_next/static/media/snooker.caa2d10d.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};